import styled from 'styled-components';

export const TemplatesListContainerStyled = styled.div`
	margin: 0;
	margin-bottom: 16px;
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 668px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

export const ListHeadingStyled = styled.h2`
	margin-top: 8px;
	margin-bottom: 16px;
	padding: 0 16px;
	font-size: 20px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 24px;
		padding: 0;
		margin-bottom: 24px;
	}
`;

export const TemplatesListStyled = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 24px;
	}
`;
